<template lang="pug">
  listagem-documentos
</template>

<script>
import ListagemDocumentos from '@/screens/assinatura/ListagemDocumentos'
export default {
  components: {
    ListagemDocumentos
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/assinatura/Home.vue